export const AiSummariesRoute = {
  AISUMMARIES: 'aisummaries',
};

export const AiSummariesPathName = {
  AISUMMARIES: 'aisummaries',
};

export const ChatGptUserRoles = {
  USER: 'user',
  SYSTEM: 'system',
  ASSISTANT: 'assistant',
};

export const ChatGptUserNames = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
  ASSISTANT: 'AI AGENT',
};

export function GetChatGptDisclaimerText() {
  return i18n.$t(
    'Note: AI supported LLMs are emerging technologies and the results should be verified before being used with customers or to make decisions regarding campaigns. TapClicks makes no claims to the accuracy or appropriateness of the information presented.'
  );
}

export function GetHumanCuratedCheckMessage() {
  return i18n.$t('Mark as Human Verified before adding to Executive Summary');
}

export const TimerSessionKey = 'chatgpt-summary-timer';
export const TimerSessionValues = {
  SHOW: 'show',
  HIDE: 'hide',
};

export const GptWidget = {
  NEW_THREAD_ID: 'NEW_GPT_THREAD_ID',
};

export const ListTypes = {
  DASHBOARD: 'dashboard',
  REPORT_STUDIO: 'report_studio',
};

export const ChatGptSummariesEvents = {
  RESET_ROUTE_DATA: 'reset-route-data',
  CLOSE_PARENT_MODAL: 'close-parent-modal',
};
